export class ClaimsAppSubmissionConstant {
    public static driveIn = "driveIn";
    public static towedIn = "towedIn";

    public static createNewComponentLabel = "Create Custom Component";
}